import { css } from '@lastbrand/web-ui-styled-system/css'

export interface EarnCreditFestivalTagProps {
  earnCreditTagFor3PVendor?: string
}

// Earn-credit tag beside the festival offer value (left-margin variant).
// The no-festival earn-credit tag lives in MainPriceColumn.
function EarnCreditFestivalTag({ earnCreditTagFor3PVendor }: EarnCreditFestivalTagProps) {
  return (
    <div
      className={css({
        paddingBlock: 'space-4',
        paddingInline: 'space-6',
        textStyle: 'body-12',
        fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
        fontWeight: 400,
        background: 'cantaloupe-80',
        backdropFilter: 'blur(2px)',
        ml: 'space-4',
      })}
    >
      {earnCreditTagFor3PVendor}
    </div>
  )
}

export default EarnCreditFestivalTag
